export default function Titel({ title, ...props }) {
  return (
    <div {...props}>
      <div className="flex flex-col items-start w-full">
        <h3 className="font-bold mb-1">{title}</h3>
        <div
          className="h-[3px] w-full bg-gradient-to-r from-blue-50 via-blue-300 to-blue-400"

        ></div>
      </div>
    </div>
  );
}
